module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_8023.6c1cf801.png";